import {useState,useEffect} from "react";
import ImageWithBasePath from "../../../img";
import FeatherIcon from "feather-icons-react";
import {Link,useLocation,useNavigate} from "react-router-dom";
import Scrollbar from "react-perfect-scrollbar-z";
import "react-perfect-scrollbar-z/build/styles.css";
import {all_routes} from "../../../../feature-module/router/all_routes";
import {setExpandMenu,setMiniSidebar} from "../../../redux/sidebarSlice";
import {useDispatch} from "react-redux";
/* -- biz9 import start -- */
import {Type,Url,Field,Title} from "../../../../constant";
import {App,Data,Dashboard,Event,Field_Logic,Image,Style,Service_Industry,User,Template,Toast_Message,Storage,System} from "../../../../project";
import {Store_Title} from "biz9-store";
import {Portal_Table} from "biz9-portal-app";
import {Review_Title} from "biz9-review";
import {User_Title} from "biz9-user";
import {Str,Log} from "biz9-utility";
/* -- biz9 import end -- */
const Dashboard_Sidebar_App = (props) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const [hide_side_bar,setHideSideBar] = useState(props.hide_side_bar);
    const [side_bar_select,setSideBarSelect] = useState(Storage.get_dashboard_side_bar_type());
    const handleToggleMiniSidebar = () => {
        const body = document.body;
        if (body.classList.contains("mini-sidebar")) {
            body.classList.remove("mini-sidebar");
            body.classList.add("expand-menu");
            dispatch(setMiniSidebar(false));
            localStorage.setItem("sidebarState", "expand-menu"); // Store state in localStorage
        } else {
            body.classList.add("mini-sidebar");
            body.classList.remove("expand-menu");
            dispatch(setMiniSidebar(true));
            localStorage.setItem("sidebarState", "mini-sidebar"); // Store state in localStorage
        }
    };
    useEffect(() => {
            setSideBarSelect(props.side_bar_select);
            const savedState = localStorage.getItem("sidebarState");
            const body = document.body;
            if (savedState === "mini-sidebar") {
            body.classList.add("mini-sidebar");
            body.classList.remove("expand-menu");
            dispatch(setMiniSidebar(true));
            } else {
            body.classList.add("expand-menu");
            body.classList.remove("mini-sidebar");
            dispatch(setMiniSidebar(false));
            }
            }, [dispatch,props]);
    async function btn_side_bar_table(table) {
        Storage.post_dashboard_side_bar(table);
    };
    const onMouseEnter = () => {
        const body = document.body;
        if (body.classList.contains("mini-sidebar")) {
            body.classList.add("expand-menu");
            dispatch(setExpandMenu(true));
            localStorage.setItem("sidebarState", "expand-menu"); // Store state in localStorage
        }
    };
    const onMouseLeave = () => {
        const body = document.body;
        if (body.classList.contains("mini-sidebar")) {
            body.classList.remove("expand-menu");
            dispatch(setExpandMenu(false));
            localStorage.setItem("sidebarState", "mini-sidebar"); // Store state in localStorage
        }
    };
    return (
            <div hidden={hide_side_bar}
            className="sidebar"
            id="sidebar"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            >
            <div className="sidebar-logo">
            <div className="d-flex align-items-center justify-content-between">
            <Link to={"#"} className="logo logo-normal">
            <ImageWithBasePath src="/assets/img/logo.png" alt="Logo" />
            </Link>
            <Link to={"#"} className="logo-small">
            <ImageWithBasePath
            src="/assets/img/logo-small.png"
            alt="Logo"
            className="img-fluid"
            />
            </Link>
            <Link to={"#"} className="dark-logo">
            <ImageWithBasePath
            src="/assets/img/dark-logo.png"
            alt="Logo"
            className="img-fluid"
            />
            </Link>
            <Link
            id="toggle_btn"
            to="#"
            className="active"
            onClick={() => {
                handleToggleMiniSidebar();
            }}
    >
        <i className="ti ti-arrow-bar-right" />
        </Link>
        </div>
        </div>
        <div className="sidebar-inner slimscroll">
        <Scrollbar maxHeight="100vh" always>
        <div id="sidebar-menu" className="sidebar-menu">
        <ul>
        <li>
        <Link to={all_routes.dashboard_app_home} onClick={(e)=>{{btn_side_bar_table(Title.USER_SIDE_BAR_DASHBOARD)}}} className={side_bar_select == Title.USER_SIDE_BAR_DASHBOARD ? "active" : ""}>
        <FeatherIcon icon="settings" />
        <span>{Title.USER_SIDE_BAR_DASHBOARD}</span>
        </Link>
        </li>
        <li>
        <Link to={all_routes.dashboard_app_blog_post} onClick={(e)=>{{btn_side_bar_table(Title.USER_SIDE_BAR_BLOG_POST)}}} className={side_bar_select == Title.USER_SIDE_BAR_BLOG_POST ? "active" : ""}>
        <FeatherIcon icon="rss" />
        <span>{Title.USER_SIDE_BAR_BLOG_POST}</span>
        </Link>
        </li>
        <li>
        <Link to={all_routes.dashboard_app_category} onClick={(e)=>{{btn_side_bar_table(Title.USER_SIDE_BAR_CATEGORY)}}} className={side_bar_select == Title.USER_SIDE_BAR_CATEGORY ? "active" : ""}>
        <FeatherIcon icon="archive" />
        <span>{Title.USER_SIDE_BAR_CATEGORY}</span>
        </Link>
        </li>
        <li>
        <Link to={all_routes.dashboard_app_content} onClick={(e)=>{{btn_side_bar_table(Title.USER_SIDE_BAR_CONTENT)}}} className={side_bar_select == Title.USER_SIDE_BAR_CONTENT ? "active" : ""}>
        <FeatherIcon icon="tv" />
        <span>{Title.USER_SIDE_BAR_CONTENT}</span>
        </Link>
        </li>
        <li>
        <Link to={all_routes.dashboard_app_custom_field} onClick={(e)=>{{btn_side_bar_table(Title.USER_SIDE_BAR_CUSTOM_FIELD)}}} className={side_bar_select == Title.USER_SIDE_BAR_CUSTOM_FIELD ? "active" : ""}>
        <FeatherIcon icon="disc" />
        <span>{Title.USER_SIDE_BAR_CUSTOM_FIELD}</span>
        </Link>
        </li>
        <li>
        <Link to={all_routes.dashboard_app_event} onClick={(e)=>{{btn_side_bar_table(Title.USER_SIDE_BAR_EVENT)}}} className={side_bar_select == Title.USER_SIDE_BAR_EVENT ? "active" : ""}>
        <FeatherIcon icon="disc" />
        <span>{Title.USER_SIDE_BAR_EVENT}</span>
        </Link>
        </li>
        <li>
        <Link to={all_routes.dashboard_app_faq} onClick={(e)=>{{btn_side_bar_table(Title.USER_SIDE_BAR_FAQ)}}} className={side_bar_select == Title.USER_SIDE_BAR_FAQ ? "active" : ""}>
        <FeatherIcon icon="clipboard" />
        <span>{Title.USER_SIDE_BAR_FAQ}</span>
        </Link>
        </li>
        <li>
        <Link to={all_routes.dashboard_app_gallery} onClick={(e)=>{{btn_side_bar_table(Title.USER_SIDE_BAR_GALLERY)}}} className={side_bar_select == Title.USER_SIDE_BAR_GALLERY ? "active" : ""}>
        <FeatherIcon icon="camera" />
        <span>{Title.USER_SIDE_BAR_GALLERY}</span>
        </Link>
        </li>

             <li>
        <Link to={all_routes.dashboard_app_order} onClick={(e)=>{{btn_side_bar_table(Title.USER_SIDE_BAR_ORDER)}}} className={side_bar_select == Title.USER_SIDE_BAR_ORDER ? "active" : ""}>
        <FeatherIcon icon="dollar-sign" />
        <span>{Title.USER_SIDE_BAR_ORDER}</span>
        </Link>
        </li>

        <li>
        <Link to={all_routes.dashboard_app_page} onClick={(e)=>{{btn_side_bar_table(Title.USER_SIDE_BAR_PAGE)}}} className={side_bar_select == Title.USER_SIDE_BAR_PAGE ? "active" : ""}>
        <FeatherIcon icon="file" />
        <span>{Title.USER_SIDE_BAR_PAGE}</span>
        </Link>
        </li>
        <li>
        <Link to={all_routes.dashboard_app_product} onClick={(e)=>{{btn_side_bar_table(Title.USER_SIDE_BAR_PRODUCT)}}} className={side_bar_select == Title.USER_SIDE_BAR_PRODUCT ? "active" : ""}>
        <FeatherIcon icon="shopping-cart" />
        <span>{Title.USER_SIDE_BAR_PRODUCT}</span>
        </Link>
        </li>
        <li>
        <Link to={all_routes.dashboard_app_review} onClick={(e)=>{{btn_side_bar_table(Title.USER_SIDE_BAR_REVIEW)}}} className={side_bar_select == Title.USER_SIDE_BAR_REVIEW ? "active" : ""}>
        <FeatherIcon icon="message-circle" />
        <span>{Title.USER_SIDE_BAR_REVIEW}</span>
        </Link>
        </li>

        <li>
        <Link to={all_routes.dashboard_app_service} onClick={(e)=>{{btn_side_bar_table(Title.USER_SIDE_BAR_SERVICE)}}} className={side_bar_select == Title.USER_SIDE_BAR_SERVICE ? "active" : ""}>
        <FeatherIcon icon="shield" />
        <span>{Title.USER_SIDE_BAR_SERVICE}</span>
        </Link>
        </li>

        <li>
        <Link to={all_routes.dashboard_app_template} onClick={(e)=>{{btn_side_bar_table(Title.USER_SIDE_BAR_TEMPLATE)}}} className={side_bar_select == Title.USER_SIDE_BAR_TEMPLATE ? "active" : ""}>
        <FeatherIcon icon="sidebar" />
        <span>{Title.USER_SIDE_BAR_TEMPLATE}</span>
        </Link>
        </li>

        <li>
        <Link to={all_routes.dashboard_app_type} onClick={(e)=>{{btn_side_bar_table(Title.USER_SIDE_BAR_TYPE)}}} className={side_bar_select == Title.USER_SIDE_BAR_TYPE ? "active" : ""}>
        <FeatherIcon icon="type" />
        <span>{Title.USER_SIDE_BAR_TYPE}</span>
        </Link>
        </li>

        <li>
        <Link to={all_routes.dashboard_app_user} onClick={(e)=>{{btn_side_bar_table(Title.USER_SIDE_BAR_USER)}}} className={side_bar_select == Title.USER_SIDE_BAR_USER ? "active" : ""}>
        <FeatherIcon icon="users" />
        <span>{Title.USER_SIDE_BAR_USER}</span>
        </Link>
        </li>

        </ul>
        <div className="sidebar-footer">
        <Link to={"#"} target="_blank">
        <i className="ti ti-logout me-2" />
        <span>Logout</span>
        </Link>
        </div>
        </div>
        </Scrollbar>
        </div>
        </div>
        );
};
export default Dashboard_Sidebar_App;
